import axios from './axios'
import { Loading } from 'element-ui';
// import { setToken } from '@/utils/auth'
import { errorHandle } from './config'
// 暴露 get post 方法供接口调用
export const get = (url, param, platform, loadFlag = false) => {
  return new Promise((resolve, reject) => {
    requestMethod(url, 'get', param, resolve, reject, platform, loadFlag);
  })
}
export const post = (url, param, platform, loadFlag = false) => {
  return new Promise((resolve, reject) => {
    requestMethod(url, 'post', param, resolve, reject, platform, loadFlag);
  })
}
export const postParam = (url, param) => {
  return new Promise((resolve, reject) => {
    requestMethod(url, 'post', param, resolve, reject, '-1');
  })
}
const requestMethod = (
  url,
  method,
  param,
  resolve,
  reject,
  postType,
  loadFlag=false
) => {

  const createObj = {
    method: method,
    url
  }
  switch (method) {
    case 'get':
      createObj.params = param;
      break;
    case 'post':
      createObj.data = param;
      break;
  }
  if (postType == -1) {
    createObj.params = param;
  }
  let loadingInstance;
  if (loadFlag) {
    loadingInstance = Loading.service({
      lock: true,
      text: '数据加载中...',
      background: 'transparent'
    });
  }

  axios(createObj).then(res => {
    if (loadFlag) {
      loadingInstance.close();
    }
    try {
      // 返回新的token并存入cookie中
      const refreshToken = res.headers.dataMarketToken;
      if (refreshToken) {
        setToken(refreshToken);
      }
      // 导出接口需特殊处理
      if (res.config.url.indexOf('downdmark') != -1) {
        resolve(res);
        return;
      }
      // 业务code == 200 or 0 才执行页面成功的then方法,也可在页面中执行错误信息处理
      if (res.status == 200) {
        // 此处可能不同的服务返回的CODE码是不同的 如果是非200 跟 0  需要在此处添加
        if (res.data.code == 200 || res.data.code == 0) {
          resolve(res.data);
          return;
        }
      }
      if (res.status) {
        errorHandle(res)
      }
      reject(res);
    } catch (error) {
    }
  }, res => {
    if (loadFlag) {
      loadingInstance.close();
    }
    if (res.response.status) {
      errorHandle(res.response)
    }
    reject(res);
  })
}

